(function (){

  //Resets the button - fixes a safari bug when the user clicks the back button
  const resetButton = () => {
    if (FS.Browser.getMake() === "safari") {
      const submitButtonEl = document.getElementById('submitFormBtn');
      if (submitButtonEl && submitButtonEl.classList.contains('fs-button--loading')) {
        submitButtonEl.classList.remove('fs-button--loading');
      }
    }
  }
  const isOnIOS = navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i);
  const eventName = isOnIOS ? "pagehide" : "beforeunload";
  window.addEventListener(eventName, resetButton);

  const surnameOnlyView = window.discoveryFormData.surnameOnlyView;
  const deathBeforeBirthValidation = window.discoveryFormData.deathBeforeBirthValidation;
  if (surnameOnlyView) {
    const surnameFieldEl = document.getElementById('surnameField');
    const surnameOnlyFieldContainerEl = document.getElementById('surnameOnlyFieldContainer');
    const surnameFullFormContainerEl = document.getElementById('surnameFullFormContainer');
    surnameOnlyFieldContainerEl.insertBefore(surnameFieldEl, null);

    const searchSpecificAncestorLink = window.discoveryFormData.searchSpecificAncestorLink;
    const showLessLink = window.discoveryFormData.showLessLink;
    const lastNameFieldTitle = window.discoveryFormData.lastNameFieldTitle;
    const lastNameFieldTitleAlt = window.discoveryFormData.lastNameFieldTitleAlt;

    const toggleFormLinkEl = document.getElementsByClassName('toggleFormLink')[0];
    const surnameOnlyFormEl = document.getElementsByClassName('formItem')[0];
    const fullFormEl = document.getElementsByClassName('fullForm')[0];
    const toggleFormTextEl = document.getElementById('toggleFormText');
    const lastNameLabelEl = document.getElementById('lastNameLabel');

    let surnameOnlyMode = true;

    const handleFormToggle = () => {
      surnameOnlyFormEl.classList.toggle('hidden');
      fullFormEl.classList.toggle('hidden');
      toggleFormLinkEl.classList.toggle('marginLeft');
      if (!surnameOnlyMode) {
        HF.jsLoaded.then(() =>{
          FS.Analytics.trackValue('NLIDiscoveryForm:ShowLess:clicked');
        });
        surnameOnlyFieldContainerEl.insertBefore(surnameFieldEl, null);
        toggleFormTextEl.innerHTML = searchSpecificAncestorLink;
        lastNameLabelEl.innerHTML = lastNameFieldTitleAlt;
      } else {
        HF.jsLoaded.then(() =>{
          FS.Analytics.trackValue('NLIDiscoveryForm:SearchSpecificAncestor:clicked');
        });
        surnameFullFormContainerEl.insertBefore(surnameFieldEl, null);
        toggleFormTextEl.innerHTML = showLessLink;
        lastNameLabelEl.innerHTML = lastNameFieldTitle;
      }
      surnameOnlyMode = !surnameOnlyMode;
    }

    toggleFormLinkEl.addEventListener('click', handleFormToggle);
    toggleFormLinkEl.addEventListener('keypress', handleFormToggle);
  }

  const checkValidDeathYear = () => {
    const birthYearEl = document.getElementById('birthYear');
    const birthVal = birthYearEl.value;
    const deathYearEl = document.getElementById('deathYear');
    const deathVal = deathYearEl.value;
    if (birthVal && deathVal && birthVal > deathVal) {
      deathYearEl.setCustomValidity(deathBeforeBirthValidation);
    } else {
      deathYearEl.setCustomValidity('');
    }
  };
  window.addEventListener('load', () => {
    const handleSymbolFail = (formItem) => {
      if (formItem.value) {
        if (/[!@#$^&%*;()<>]/g.test(formItem.value)) {
          formItem.setCustomValidity(window.discoveryFormData.specialCharacterMessage);
        } else {
          formItem.setCustomValidity("");
        }
      } else {
        formItem.setCustomValidity("");
      }
    }
    const checkValidLastNameInput = () => {
      handleSymbolFail(document.getElementById('lastName'));
    };
    const checkValidFirstNameInput = () => {
      handleSymbolFail(document.getElementById('firstName'));
    }
    const checkValidBirthPlaceInput = () => {
      handleSymbolFail(document.getElementById('birthplace'));
    }
    const checkValidDeathPlaceInput = () => {
      handleSymbolFail(document.getElementById('deathPlace'));
    }

    document.getElementById('lastName').addEventListener('input', checkValidLastNameInput);
    document.getElementById('firstName').addEventListener('input', checkValidFirstNameInput);
    document.getElementById('birthplace').addEventListener('input', checkValidBirthPlaceInput);
    document.getElementById('deathPlace').addEventListener('input', checkValidDeathPlaceInput);

     // for the surname page
    const lastNameSearchInput = document.getElementById('lastNameSearch');
    if (lastNameSearchInput) {
      const checklastNameSearchInput = () => {
        handleSymbolFail(lastNameSearchInput);
      }
      lastNameSearchInput.addEventListener('input', checklastNameSearchInput);
    }

  });
  document.getElementById('birthYear').addEventListener('change', checkValidDeathYear);
  document.getElementById('deathYear').addEventListener('change', checkValidDeathYear);

  const handleFormSubmitButton = event => {
    const formEl = document.getElementById('discoveryForm');
    if (!formEl.checkValidity()) return;
    const submitButtonEl = document.getElementById('submitFormBtn');
    if (submitButtonEl.classList.contains('fs-button--loading')) {
      event.preventDefault();
    } else {
      submitButtonEl.classList.add('fs-button--loading');
    }
  }

  document.getElementById('submitFormBtn').addEventListener('click', handleFormSubmitButton);
}());

/**
 * Disables all the input fields that don't have a value. This will clean up the submitted
 * query to not have blank values.
 *
 * E.g. `/nli-discovery?givenName=&surname=Doe&birthPlace=&birthDate=&deathPlace=&deathDate=`
 * now becomes `/nli-discovery?surname=Doe`
 * @param {HTMLFormElement} formEl discovery form element
 * @returns {void}
 */
const onDiscoveryFormSubmit = formEl => {
  Home.trackDiscoveryForm(formEl);
  const inputEls = formEl.querySelectorAll('input');
  var surnameOnly = true;
  inputEls.forEach(el => {
    if (!el.value) el.disabled = true;
    else if (el.value && el.name != "surname") surnameOnly = false;
  });
  if (surnameOnly) {
    document.getElementById('discoveryForm').action = "/surname";
  }
};
